import { Injectable } from '@angular/core';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { filter, mergeMap, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  getReferenceData,
  getReferenceDataError,
  getReferenceDataSuccess,
} from './accounting.action';
import { Store } from '@ngrx/store';
import { AccountingService } from '../service/accounting.service';
import { Router } from '@angular/router';
import {
  selectCompanyInfo,
} from './accounting.selector';
import { LocalStorageService } from '../../home/services/local-storage.service';
import { hideLoading, showLoading } from '../../core/store/app.actions';

@Injectable({
  providedIn: 'root',
})
export class AccountingEffects {

  constructor(
    private actions$: Actions,
    private accountingService: AccountingService,
    private localStorageService: LocalStorageService,
    private store: Store<any>,
    private router: Router,
  ) {
  }

  showLoadingEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(getReferenceDataSuccess),
      map(() => showLoading())
    );
  });

  hideLoadingEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(
        getReferenceDataSuccess,
        getReferenceDataError
      ),
      map(() => hideLoading())
    );
  });

  getReferenceDataEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(getReferenceData),
      concatLatestFrom(() => [this.store.select(selectCompanyInfo)]),
      filter(([, companyData]) => !companyData),
      mergeMap(() => this.accountingService.getCompanyData().pipe(
          map((companyData) =>
            getReferenceDataSuccess({ companyData })
          ),
          catchError((error) => {
            if (this.localStorageService.hasIdfInfo()) {
              void this.router.navigateByUrl('/startup', { replaceUrl: true });
              this.localStorageService.destroyIdpInfo();
            }
            return of(getReferenceDataError({ error }))
          })
        )
      )
    );
  });
}
